import { AssertEqualType } from '@lessonup/domain-utils';
import { z } from 'zod';
import { AnswerByCategoryPinSchema } from './answer-by-category-pin';
import { DragAndDropPinSchema } from './drag-and-drop-pin';
import { FillInTheBlanksPinSchema } from './fill-in-the-blanks-pin';
import { OpenQuestionPinSchema } from './open-question-pin';
import { PollPinSchema } from './poll-pin';
import { QuizPinSchema } from './quiz-pin';
import { SlidePinSchema } from './slide-pin';
import { SortingQuestionPinSchema } from './sorting-question-pin';
import { UnsupportedPinSchema } from './unsupported-pin';
import { WordCloudPinSchema } from './word-cloud-pin';

export type PinId = string;
export type PinComponentId = string;

export const allPinTypes = [
  'MULTIPLE_CHOICE',
  'SLIDE',
  'OPEN_QUESTION',
  'WORD_CLOUD',
  'ANSWER_BY_CATEGORY',
  'POLL',
  'FILL_IN_THE_BLANKS',
  'SORTING_QUESTION',
  'DRAG_AND_DROP',
  'UNSUPPORTED',
] as const;

export const DbPinTypeSchema = z.enum(allPinTypes);

export type PinType = (typeof allPinTypes)[number];

export const pinInteractiveTypes = [
  'MULTIPLE_CHOICE',
  'OPEN_QUESTION',
  'WORD_CLOUD',
  'POLL',
  'ANSWER_BY_CATEGORY',
  'FILL_IN_THE_BLANKS',
  'SORTING_QUESTION',
  'DRAG_AND_DROP',
] as const satisfies readonly PinType[];

export const pinCustomizableTypes: PinType[] = [
  'SLIDE',
  'MULTIPLE_CHOICE',
  'OPEN_QUESTION',
  'WORD_CLOUD',
  'POLL',
  'ANSWER_BY_CATEGORY',
  'DRAG_AND_DROP',
];

export const pinTypesWithCorrectAnswers: PinType[] = ['MULTIPLE_CHOICE', 'FILL_IN_THE_BLANKS', 'SORTING_QUESTION'];

export const PinSchema = z.discriminatedUnion('type', [
  QuizPinSchema,
  SlidePinSchema,
  OpenQuestionPinSchema,
  WordCloudPinSchema,
  AnswerByCategoryPinSchema,
  PollPinSchema,
  FillInTheBlanksPinSchema,
  SortingQuestionPinSchema,
  DragAndDropPinSchema,
  UnsupportedPinSchema,
]);
export type Pin = z.infer<typeof PinSchema>;

// If this gives you an error, update the PinSchema union
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ensureTypesAreInSync: AssertEqualType<PinType, Pin['type']> = true;
